var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-absolute tw-right-0 tw-top-0 tw-z-50"},[_c('IconButton',{on:{"click":(e) => _vm.$emit('click', e)}},[_c('CloseIcon',{staticClass:"tw-text-[#111827] tw-text-xl"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }